var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"p-4 min-h-screen flex flex-col justify-center"},[_c('div',{staticClass:"mb-8"},[_c('logos')],1),_c('intro')],1)}
var staticRenderFns = []

export { render, staticRenderFns }